import { gql } from '@apollo/client'
import { DropdownOption } from 'shared/models/dropdownOption'

export interface EducationOptions {
    degreeTypes: DropdownOption[]
    colleges: DropdownOption[]
    mbaColleges: DropdownOption[]
    majors: DropdownOption[]
    programs: DropdownOption[]
}

export const EducationOptionsQuery = gql`
    query GetEducationOptions {
        degreeTypes {
            id
            value
        }
        colleges {
            id
            value
        }
        mbaColleges {
            id
            value
        }
        majors {
            id
            value
        }
        programs {
            id
            value
        }
    }
`
